import { RoleService } from '../../../open-age/core/services/role.service';
import { PagerBaseComponent } from '../../../open-age/core/structures/pager/pager-base.component';
import { PatientReportService } from '../../../open-age/telepain/services/patient-report.service';
import { PatientReport } from '../../../open-age/telepain/models/patient-report';
import { Appointment } from '~/app/open-age/welcome/models/appointment.model';
import { Component, Input, OnInit, ErrorHandler } from '@angular/core';
import { DocsService } from '~/app/open-age/drive/services';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-appointment-reports',
  templateUrl: './appointment-reports.component.html',
  styleUrls: ['./appointment-reports.component.css']
})
export class AppointmentReportsComponent extends PagerBaseComponent<PatientReport> implements OnInit {

  displayedColumns: string[] = ['reportid', 'date', 'id', 'name', 'gender', 'dob', 'email', 'phone', 'action', 'action2'];

  @Input()
  appointment: Appointment;

  reports: PatientReport[] = [];

  constructor(
    private authService: RoleService,
    private docService: DocsService,
    private reportService: PatientReportService,
    private errorHandler: ErrorHandler
  ) {
    super({
      api: reportService,
      errorHandler,
      filters: [
        'appointmentId'
      ],
      pageOptions: {
        limit: 5,
        offset: 0,
      },
    })
  }

  ngOnInit() {
    this.search();
  }

  public search(): void {
    this.filters.set('appointmentId', this.appointment.id);
    this.fetch({ offset: 0, limit: 5 }).subscribe();
  }

  public download(report: PatientReport): void {
    this.isProcessing = true
    this.docService.downloadPdf('pre-appoitment-report', `${report.id}`, {
      'access_token': this.authService.getRole()
    }).subscribe((response) => {
      this.isProcessing = false
      let name = `${report.patient.profile.lastName}_${report.patient.profile.firstName}_${moment(report.date).format('MM-DD-YYYY')}_OFAA`
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none;');
      var csvUrl = URL.createObjectURL(response);
      a.href = csvUrl;
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href)
      a.remove();
    }, (err) => {
      this.isProcessing = false
    });
  }

  public view(report: PatientReport) {

    let driveUrl: String = ''

    if (environment.services && environment.services.length) {
      const service = environment.services.find((s) => s.code === 'drive');
      if (service) {
        driveUrl = service.url
      }
    }

    if (!driveUrl) {
      const tenant = this.authService.currentTenant();
      if (tenant && tenant.services) {
        const service = tenant.services.find((s) => s.code === 'drive');
        if (service) {
          driveUrl = service.url;
        }
      }
    }
    let url = `${driveUrl}/docs/pre-appoitment-report/${report.id}.pdf?access_token=${this.authService.getRole()}`
    window.open(url, "_blank");
  }

}